import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import PriceCard from 'layouts/projects/Forms/SheetTemplates/SheetTemplateForm/components/RetrievePriceAndNames/PriceCard';
import { SHEET_TYPES, SHEET_FIELDS, PRICE_CARD_CONFIGS } from '../../constants';

const getSheetDataValue = (sheetData, sheetName, key) => sheetData[sheetName + '!' + key]?.[0]?.[0];

const RetrievePriceAndNames = ({
    queryClient,
    handleClose,
    demandID,
    templateImage,
    type,
    sheetName,
    sheetData,
    lock,
    setLock,
}) => {
    // type'ı SHEET_TYPES içindeki değerlerle eşleştir
    const sheetType = Object.values(SHEET_TYPES).find((t) => t.toLowerCase() === type.toLowerCase());

    if (!sheetType) {
        console.error(`Unsupported sheet type: ${type}`);
        return null;
    }

    const fields = SHEET_FIELDS[sheetType];
    const miktar = getSheetDataValue(sheetData, sheetName, fields.MIKTAR);

    const priceCardConfigs = PRICE_CARD_CONFIGS[sheetType].map((config) => ({
        ...config,
        name: getSheetDataValue(sheetData, sheetName, fields[config.nameField]),
        price: getSheetDataValue(sheetData, sheetName, fields[config.priceField]),
        amount: miktar * config.amountMultiplier,
    }));

    if (priceCardConfigs.length === 0) {
        return null;
    }

    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 3,
                }}
            >
                <Typography
                    variant="h6"
                    sx={{
                        color: "#1E293B",
                        fontWeight: 600
                    }}>
                    Fiyat Seçenekleri
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        color: "#64748B",
                        display: 'flex',
                        alignItems: 'center',

                        '&::before': {
                            content: '""',
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: '#3ECF8E',
                            display: 'inline-block',
                            marginRight: '8px',
                        }
                    }}>
                    Seçim yapmak için bir karta tıklayın
                </Typography>
            </Box>
            <Grid container spacing={2}>
                {priceCardConfigs.map((config, index) => (
                    <Grid
                        key={index}
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 4
                        }}>
                        <PriceCard
                            icon="add"
                            baslik={config.label}
                            ekNot={config.name}
                            verilenFiyat={config.price}
                            miktar={config.amount}
                            color="#3ECF8E"
                            queryClient={queryClient}
                            handleClose={handleClose}
                            demandID={demandID}
                            templateImage={templateImage}
                            type={type}
                            sheetName={sheetName}
                            sheetData={sheetData}
                            lock={lock}
                            setLock={setLock}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default RetrievePriceAndNames;
